module.exports = __webpack_public_path__ + "static/media/flag-uk.50f007b5.webp";